import { defineComponent as _defineComponent } from 'vue'
import {computed, onBeforeMount, reactive, ref, watch} from 'vue';
import {
    getEngineeringCategory,
    getEngineeringDetail,
    EngineerRecommendList,
    login,
    getEngineerRecommendList,
    getEngineerContact,
} from '@/api/miscellaneous';
import {useRoute, useRouter} from 'vue-router';
import config from '@/config';
import userStoreModule from '@/store/modules/user';
import RestrictDialog from '@/components/RestrictDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EngineeringDetail',
  setup(__props, { expose }) {
  expose();

const {push} = useRouter();
const isShow = ref(false);
const detail = ref({});
const category = ref([]);
const {query} = useRoute();
const getListData = ref<EngineerRecommendList>({
    id: query.id as string,
    page: 1,
    size: 10,
    categoryId: '',
});
const list = ref<any[]>([]);
const listLoading = ref(false);
const finished = ref(false);
const restrictShow = ref(false);
const restrictCode = ref('');
const isShowTel = ref(false);
const tel = ref('');

const classes = computed(() => {
    return {
        show: isShow.value,
    };
});

onBeforeMount(() => {
    // getData();
    let {code, id, purchaseid, state} = query;
    const getId = (id || state) as string;

    // if (userStoreModule.token) {
    getListData.value.id = getId;
    getData();
    getCategory();
    getList();
    // } else {
    //     pagelogin();
    // }
});

const pagelogin = () => {
    let {code, id, purchaseid, state} = query;
    if (!code) {
        /**
         * 微信登录Code授权
         * 重定向页面还是这个页面，通过$roter.query.code 判断是否是重定向回来的
         * */
        const redirectUri = encodeURIComponent(`${config.webHost}${window.location.pathname}`);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.wechat.appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${id}#wechat_redirect`;
    } else {
        const getId = (id || state) as string;
        getListData.value.id = getId;
        login({code: code as string}).then(res => {
            let {token, encrypt} = res;
            userStoreModule.setToken(token);
            userStoreModule.setEncrypt(encrypt);
            // this.getDetail((state || id) as string);
            getData({id: getId as string});
            getCategory({id: getId as string});
            getList();
        });
    }
};

const getData = (data?: {id: string}) => {
    getEngineeringDetail(data || {id: getListData.value.id}).then(res => {
        detail.value = res;
    });
};

const getCategory = (data?: {id: string}) => {
    const id = query.id as string;
    getEngineeringCategory(data || {id: getListData.value.id}).then(res => {
        category.value = res;
        // getListData.value.categoryId = res[0].key;
    });
};

const getList = () => {
    if (listLoading.value) return;
    listLoading.value = true;
    getEngineerRecommendList(getListData.value).then(res => {
        listLoading.value = false;
        res.items = res.items.map((el: any) => {
            el.specifications = JSON.parse(el.specifications).map((el2: any) => {
                const value = Array.isArray(el2.value) ? el2.value.join('~') : el2.value;
                return `${el2.name}:${value}${el2.unit}`;
            });
            return el;
        });
        list.value = [...list.value, ...res.items];
        getListData.value.page = getListData.value.page + 1;
        finished.value = res.totalCount == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};

const getTel = () => {
    getEngineerContact({id: getListData.value.id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
            // alert('suc:' + JSON.stringify(res));
        })
        .catch(e => {
            // alert('err:' + JSON.stringify(e));
            let {code} = e;
            if ([104, 107].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

watch(
    () => getListData.value.categoryId,
    () => {
        list.value = [];
        getListData.value.page = 1;
        getList();
    },
);

const setCategory = (val: any) => {
    getListData.value.categoryId = val;
};

const __returned__ = { push, isShow, detail, category, query, getListData, list, listLoading, finished, restrictShow, restrictCode, isShowTel, tel, classes, pagelogin, getData, getCategory, getList, getTel, setCategory, computed, onBeforeMount, reactive, ref, watch, getEngineeringCategory, getEngineeringDetail, EngineerRecommendList, login, getEngineerRecommendList, getEngineerContact, useRoute, useRouter, config, userStoreModule, RestrictDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})